import { HttpErrorResponse } from '@angular/common/http';

/**
 * The payload of a legacy-backend error response.
 *
 * `HTTPError` serialises as `{name, statusCode, data}`, so the fields the backend keyed
 * the failure by — `giftCardExpired`, `usableTimes`, `reason` … — sit one level down under
 * `data`, not on the body itself. Reading them off the body returns `undefined` for every
 * real failure, which classifies as "unknown" and shows the customer a generic retry
 * message instead of the reason.
 *
 * Unwrapped bodies are still accepted, for endpoints that already return the modern
 * backend's plainer shape.
 */
export function legacyErrorBody(err: unknown): Record<string, unknown> | null {
  if (!(err instanceof HttpErrorResponse)) return null;

  const raw: unknown = err.error ?? null;
  if (raw === null || typeof raw !== 'object') return null;

  const nested = (raw as { data?: unknown }).data;
  const body = nested !== undefined && nested !== null ? nested : raw;
  return typeof body === 'object' ? (body as Record<string, unknown>) : null;
}
